var styles = {"iframe":"bc-exercise-iframe__iframe"};

export { styles as default };
